import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DndModule } from 'ngx-drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { ColorPickerModule } from 'ngx-color-picker';
import { FormBuilderSharedModule } from '@app/form-builder/shared';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { FormBuilderComponent } from './form-builder/form-builder/form-builder.component';
import { FormParserComponent } from './form-builder/form-builder/form-parser/form-parser.component';
import { HomeLayoutComponent, LoginLayoutComponent } from './layout';
import {
  BrokerGroupAddEditComponent,
  SurveyAddEditComponent,
  BrokerAdminAddComponent,
  HeaderComponent,
  SidebarComponent,
  BrokerAdminListComponent,
  BodyComponent,
  BrokerGroupListComponent,
  SurveyListComponent,
  PersonnelListComponent,
  FormsListComponent,
  LoginComponent,
  HomeComponent,
  SurveyDetailsComponent,
  BrokerListComponent,
  BrokerAddComponent,
  ClientListComponent,
  ClientAddComponent,
  ConductDetailComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent
} from '@app/views';
import { InterceptorService, LocalStorageService, AuthService, BrokerAdminService, SurveyService, BrokerGroupService, FormService, BrokerService, ClientService, ConductService, FileUploaderService, FormGroupService } from './services';
import { SessionGuard } from './routes/sessionGuard';
import { BreadcrumbComponent, PageHeaderComponent, SlidePanelComponent, PageContentComponent, DataGridComponent } from '@app/components';
import { BrowserTransferStateModule } from '@angular/platform-browser';
import {
  DxCheckBoxModule,
  DxDataGridModule,
  // DxHtmlEditorModule,
  // DxScrollViewModule,
  DxSelectBoxModule,
  // DxSortableModule,
  DxTextAreaModule,
  DxSwitchModule,
  DxButtonModule,
  DxTabsModule,
  DxPopupModule,
  DxTagBoxModule,
  DxTextBoxModule,
  // DxFormModule,
  DxLoadPanelModule,
  DxNumberBoxModule,
  DxMultiViewModule,
  // DxValidatorModule,
  DxPieChartModule
} from 'devextreme-angular';
import { FormStateService } from './form-builder/form-builder/form-state.service';
import { ConductListComponent } from './views/conduct/conduct-list/conduct-list.component';
import { LocationComponent } from './components/location/location.component';
// import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { GoogleMapsAPIWrapper, MapsAPILoader } from '@agm/core';
import { AgmCoreModule } from '@agm/core';
import { LoaderComponent } from './components/loader/loader.component';
import { AlertComponent } from './components/alert/alert.component';

import { SideBarDirective } from './views/sidebar/sidebar.directive';
import { ConductDashboardReportComponent } from './views/home/conduct-dashboard-report/conduct-dashboard-report.component';
import { ProfileComponent } from './views/profile/profile.component';
@NgModule({
  declarations: [
    AppComponent,
    FormParserComponent,
    FormBuilderComponent,
    HeaderComponent,
    SidebarComponent,
    HomeLayoutComponent,
    LoginLayoutComponent,
    LoginComponent,
    HomeComponent,
    BodyComponent,
    BrokerAdminListComponent,
    PageHeaderComponent,
    PageContentComponent,
    SlidePanelComponent,
    DataGridComponent,
    BrokerGroupListComponent,
    SurveyListComponent,
    PersonnelListComponent,
    BrokerAdminAddComponent,
    SurveyAddEditComponent,
    BrokerGroupAddEditComponent,
    FormsListComponent,
    BreadcrumbComponent,
    SurveyDetailsComponent,
    BrokerListComponent,
    BrokerAddComponent,
    ClientListComponent,
    ClientAddComponent,
    ConductListComponent,
    ConductDetailComponent,
    LocationComponent,
    LoaderComponent,
    AlertComponent,
    SideBarDirective,
    ConductDashboardReportComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ProfileComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ColorPickerModule,
    DndModule,
    NgbModule,
    TranslateModule.forRoot(),
    FormBuilderSharedModule,
    ReactiveFormsModule,
    HttpClientModule,

    DxCheckBoxModule,
    DxDataGridModule,
    // DxHtmlEditorModule,
    // DxScrollViewModule,
    DxSelectBoxModule,
    // DxSortableModule,
    DxTextAreaModule,
    DxSwitchModule,
    BrowserTransferStateModule,
    DxButtonModule,
    DxTabsModule,
    DxPopupModule,
    DxTagBoxModule,
    DxTextBoxModule,
    // DxFormModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxMultiViewModule,
    // DxValidatorModule,
    // GooglePlaceModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyASmdHoarBNI3CbWZHh-xmlvpxftAIWij8&libraries=geometry,places',
      libraries: ["places"]
    }),
    DxPieChartModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    LocalStorageService,
    AuthService,
    SessionGuard,
    BrokerAdminService,
    SurveyService,
    BrokerGroupService,
    FormService,
    BrokerService,
    ClientService,
    FormStateService,
    ConductService,
    GoogleMapsAPIWrapper,
    FileUploaderService,
    FormGroupService
  ],
  bootstrap: [AppComponent],
  exports: [
    DxNumberBoxModule
  ]
})
export class AppModule { }
